export * from './lib/material.module';
